<template lang="pug">
  .notification
    strong Valor Unitario:&nbsp
    | {{ parseFloat(vu.valorUnitario).toFixed(2) }}
    br
    strong Dólar actual:&nbsp
    | {{ parseFloat(vu.dolar).toFixed(2) }}
    br
</template>

<script>
  export default {
    name: 'CardValores',
    props: {
      vu: {
        type: Object,
        default: {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/CardValores.vue